import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';

import { DatacenterType } from '../../../../shared/models/datacenter-aggrid-view';
import { ORDER_NUMBER_OPTIONS } from '../../../../shared/models/list';
import { CUSTOMER } from '../../../../shared/models/settings';
import { EMPTYSPACE, UNDERSCORE } from '../../../../shared/utils/constant';
import { Document, DocumentLine, OrderNumbers } from '../../../models/document';
import { DocumentService } from '../../../services/documents.service';
import { SafeUrlPipe } from '../../../../shared/pipes/safeurl.pipe';
import { NumberPipe } from '../../../../shared/pipes/number.pipe';
import { DatePipe } from '../../../../shared/pipes/date.pipe';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-invoice',
	templateUrl: './invoice.component.html',
	styleUrl: '../commercial-documents-list.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MatIconModule,
		TranslateModule,
		RouterLink,
		MatRippleModule,

		MatButtonModule,
		NgFor,
		LoadingSpinnerComponent,
		DatePipe,
		NumberPipe,
		SafeUrlPipe
	]
})
export class InvoiceComponent implements OnInit {
	@Input() document?: Document;
	@Input() orderDisplay?: keyof typeof ORDER_NUMBER_OPTIONS;
	@Input() getUniqueOrderName?: (document: Document) => OrderNumbers[];
	@Output() readonly createFilter = new EventEmitter<{ document: Document; filterType: DatacenterType }>();
	readonly UNDERSCORE = UNDERSCORE;
	readonly EMPTYSPACE = EMPTYSPACE;
	orderLable = '';
	orderNumbers: OrderNumbers[] = [];

	constructor(
		private readonly documentService: DocumentService
	) {}

	ngOnInit() {
		this.orderLable = this.orderDisplay === CUSTOMER
			? 'commercial-documents.customer-order-number'
			: 'commercial-documents.supplier-order-number';
		if (this.getUniqueOrderName === undefined || !this.document) {
			return;
		}
		this.orderNumbers = this.getUniqueOrderName(this.document);
	}

	totalCalculation(documentLines: DocumentLine[], type: string) {
		const orderReference = new Set<string>();
		let sum = 0;
		switch (type) {
		case 'invoiceAmount':
			for (const line of documentLines) {
				const ref = !line.supplierOrderReferenceItem
					? `${ line.supplierOrderReference }/${ line.dispatchAdviceNumber }`
					: `${ line.supplierOrderReference }/${ line.supplierOrderReferenceItem }/${
						line.dispatchAdviceNumber }`;
				if (!orderReference.has(ref)) {
					orderReference.add(ref);
					sum += line.invoiceAmount;
				}
			}
			break;
		case 'invoicedQuantity':
			for (const line of documentLines) {
				const ref = !line.supplierOrderReferenceItem
					? `${ line.supplierOrderReference }/${ line.dispatchAdviceNumber }`
					: `${ line.supplierOrderReference }/${ line.supplierOrderReferenceItem }/${
						line.dispatchAdviceNumber }`;
				if (!orderReference.has(ref)) {
					orderReference.add(ref);
					sum += line.invoicedQuantity;
				}
			}
			break;
		}
		return sum;
	}

	formatInvoicedQuantity(document: Document) {
		return document.invoicedQuantity;
	}

	callFilter(document: Document, filterType: DatacenterType) {
		this.createFilter.emit({ document, filterType });
	}

	downloadDocument(id: number, filename: string) {
		return this.documentService.getDownloadDocumentUrl(id, filename);
	}

	getDocumentURL(id: number, filename: string) {
		return this.documentService.getViewDocumentUrl(id, filename);
	}
}
